import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import User from 'components/ControlledUser'
import {
  Content,
  ContentHeader,
  ContentTitle,
  ContentIcon
} from 'components/Content'
import {
  ToggleModal
} from 'components/Modal'
import KanBoIcon from 'components/KanBoIcon'
import classes from '../Users.module.scss'

export class Observers extends React.Component {
  static propTypes = {
    observers: PropTypes.array.isRequired
  }

  state = {
    show: false
  }

  hideModalToggle = () => {
    this.setState({
      show: false
    })
  }

  handleModalToggle = (show) => {
    this.setState({
      show
    })
  }

  render () {
    const {
      observers
    } = this.props
    const {
      show
    } = this.state

    return observers.length > 0 ? (
      <ToggleModal
        backdrop
        show={show}
        onToggle={this.handleModalToggle}
        attachment='top left'
        targetAttachment='top left'
        constraints={[
          {
            to: 'window',
            pin: true
          }
        ]}
      >
        <ContentIcon>
          <KanBoIcon name='kanbo-16-followers' />
          <span style={{ fontSize: 14, marginLeft: '0.25em' }}>{observers.length}</span>
        </ContentIcon>
        <div className={classes.modalWrapper}>
          <Content className={classes.modal} style={{ padding: 0 }}>
            <ContentHeader className={classes.modalHeader}>
              <ContentIcon>
                <KanBoIcon name='kanbo-16-followers' />
              </ContentIcon>
              <ContentTitle>
                <FormattedMessage
                  id='CARD_FOLLOWERS'
                  values={{
                    count: observers.length.toString()
                  }}
                />
              </ContentTitle>
            </ContentHeader>
            <div style={{ overflow: 'auto' }}>
              {observers.map(userId =>
                <User
                  listItem
                  key={userId}
                  id={userId}
                  defaultMenu
                  presence
                  onShowProfile={this.hideModalToggle}
                  onShowActivities={this.hideModalToggle}
                />
              )}
            </div>
          </Content>
        </div>
      </ToggleModal>
    ) : null
  }
}

export default Observers
